import { IconProps } from "../../../types/style";

const InfoFillCircle = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 1.5C3.245 1.5 1 3.745 1 6.5C1 9.255 3.245 11.5 6 11.5C8.755 11.5 11 9.255 11 6.5C11 3.745 8.755 1.5 6 1.5ZM5.625 4.5C5.625 4.295 5.795 4.125 6 4.125C6.205 4.125 6.375 4.295 6.375 4.5V7C6.375 7.205 6.205 7.375 6 7.375C5.795 7.375 5.625 7.205 5.625 7V4.5ZM6.46 8.69C6.435 8.755 6.4 8.805 6.355 8.855C6.305 8.9 6.25 8.935 6.19 8.96C6.13 8.985 6.065 9 6 9C5.935 9 5.87 8.985 5.81 8.96C5.75 8.935 5.695 8.9 5.645 8.855C5.6 8.805 5.565 8.755 5.54 8.69C5.515 8.63 5.5 8.565 5.5 8.5C5.5 8.435 5.515 8.37 5.54 8.31C5.565 8.25 5.6 8.195 5.645 8.145C5.695 8.1 5.75 8.065 5.81 8.04C5.93 7.99 6.07 7.99 6.19 8.04C6.25 8.065 6.305 8.1 6.355 8.145C6.4 8.195 6.435 8.25 6.46 8.31C6.485 8.37 6.5 8.435 6.5 8.5C6.5 8.565 6.485 8.63 6.46 8.69Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default InfoFillCircle;
